<div class="product-info--modal">
  <img [src]="imageUrl()" [alt]="alt()" />
  <button class="close" aria-label="Fechar" (click)="close()">✕</button>
</div>
